import {texts} from "@/mixins/config"
import axios from "axios"
export const globals = {
  // mixins: [config],
  computed: {
    statusBarHeaderTop: function() {
      if (window.webkit) {
        var iHeight = window.screen.height;
        var iWidth = window.screen.width;
        if (iWidth === 414 && iHeight === 896) {
        // return "Xmax-Xr-11-Xs Max";
        return "44px";
        }
        else if (iWidth === 375 && iHeight === 812) {
          // return "X-Xs-11 Pro";
          return "40px";
        }
        else if (iWidth === 390 && iHeight === 844) {
          // return "12-12 Pro";
          return '40px';
        }
        else if (iWidth === 428 && iHeight === 926) {
          // return "12 Pro Max";
          return '44px';
        }
        else if (iWidth === 360 && iHeight === 780) {
          // return "12 Mini";
          return '40px';
        }
        else if (iWidth === 320 && iHeight === 480) {
          // return "4";
          return "40px";
        }
        else if (iWidth === 375 && iHeight === 667) {
          // return "6";
          return "20px";
        }
        else if (iWidth === 414 && iHeight === 736) {
          // return "6+";
          return "20px";
        }
        else if (iWidth === 320 && iHeight === 568) {
          // return "5";
          return "40px";
        }
        else if (iHeight <= 480) {
          // return "2-3";
          return "40px";
        }
      } else {
        return '0px';
      }
    },
    headerTitle: function() {
      return this.$store.state.headTitle;
    },
    isOnMobile: function () {
      var windowOuterWidth = window.outerWidth;
      if (windowOuterWidth <= 768) {
        return true;
      } else {
        return false;
      }
    },
    useWallet: function () {
      return this.$store.state.user.use_wallet;
    },
    totalUserPointsEarned: function() {
      return this.$store.state.totalUserPoints;
    },
    countDown: function() {
      return this.$store.state.countDownTimer;
    },
    showBackButton: function() {
      return this.$route.path != "/" || this.$route.path != "/main_page";
    },
    nativeSDK: function () {
      if (window.webkit) {
        return true;
      } else {
        return false;
      }
    },
    backButtonVisible: function () {
      if (!this.nativeSDK) {
        var path = this.$route.path;
        return path != "/";
      } else {
        return true;
      }
    },
    showHistory: function() {
      // return this.$route.fullPath.indexOf('/history') < 0;
      return this.$store.state.showHistory;
    },
    showWallet: function() {
      // return this.$route.fullPath.indexOf('/history') < 0;
      return this.$store.state.showWallet;
    },
    userName: function() {
      return this.$store.state.user.userName;
    },
    userPhone: function() {
      return this.$store.state.user.phone;
    },
    extUid: function() {
      return this.$store.state.user.ext_uid;
    },
    partnerID: function() {
      return this.$store.state.partner;
    },
    gameID: function() {
      return this.$store.state.game;
    },
    langCode: function () {
      return this.$store.state.lang;
    },
    isValidRequest: function() {
      var self = this;
      var user_name = self.userName;
      var contact_number = self.extUid;
      var partner = self.partnerID;
      // console.log(contact_number, partner, user_name)
      if(contact_number && partner) {
        return true;
      } else {
        return false;
      }
    },
    alertInfo: function() {
      return this.$store.state.isInfo;
    },
    showAlert: function() {
      return this.$store.state.alert;
    },
    alertMessage: function() {
      return this.$store.state.alertText;
    },
    isHeader: function() {
      return this.$store.state.showHeader;
    },
    userHeaderBalance: function() {
      return this.$store.state.user.headerBalance;
    },
    shareMessage: function() {
      return this.$store.state.shareText;
    },
    walletType: function() {
      return this.$store.state.wallet.type;
    },
    enableWalletClick: function() {
      return false;//this.$store.state.wallet.type == "cash";
    },
    hasJoined: function() {
      return this.$store.state.user.joined;
    },
    currentRank: function() {
      return this.$store.state.user.rank;
    },
    chancesLeft: function() {
      return this.$store.state.user.chancesLeft;
    },
    isTRPending: function() {
      return this.$store.state.requestedTR;
    },
    isRedeemable: function() {
      return this.$store.state.redeem;
    },
    isSuccess: function() {
      return this.$store.state.success;
    },
    totalEarnedCash: function() {
      return this.$store.state.user.cash;
    },
    isProcessing: function() {
      return this.$store.state.processing;
    },
    allTournamentsList: function() {
      return this.$store.state.allTournamentsList;
    },
    bgTheme: function() {
      return this.$store.state.bg_theme;
    },
    darkerBg: function() {
      var color = this.bgTheme;
      return '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + -20)).toString(16)).substr(-2));
    },
    isGiftPopup: function() {
      return this.$store.state.show_gift_modal;
    },
    giftContent: function() {
      return this.$store.state.gift_content;
    },
    isGCBuy: function() {
      return this.$store.state.giftCardBuy;
    },
    isShowMilestoneModal: function () {
      return this.$store.state.show_mile_stone_modal;
    },
    isGamification: function() {
      return this.$store.state.hasGamification;
    },
    userCurrLevel: function() {
      return this.$store.state.user.currLevel;
    },
    userCurrLevelIcon: function() {
      return this.$store.state.user.currLevelIcon;
    },
    userCheckins: function() {
      return this.$store.state.user.milestones;
    },
    milestones: function() {
      return this.$store.state.user.mile_stones;
    },
    showToast: function() {
      return this.$store.state.toast;
    },
    toastMessage: function() {
      return this.$store.state.toastMsg;
    },
    userBalances: function() {
      return this.$store.state.user.balances;
    },
    userReferralBalances: function() {
      return this.$store.state.user.referral_balances;
    },
    walletTransData:function() {
      return this.$store.state.wallet_data;
    },
    referralWalletData: function () {
      return this.$store.state.user.referralWalletData;
    },
    hasPartnerToken: function() {
      var headers = this.$store.getters.headers;
      return (headers && headers['X-Key']) ? true : false;
    },
    showExitModal: function() {
      return this.$store.state.showExitModal;
    },
    showQuizHistoryMenu: function() {
      return this.$store.state.showQuizHistoryMenu;
    },
    quizDetailsTitle: function() {
        return this.$store.state.quizDetailsTitle;
    },
    offersShowCurrencyList: function() {
        return this.$store.state.user.offers_show_currency_list;
    },
    offersShowCurrencyName: function() {
        return this.$store.state.user.offers_show_currency_name;
    },
    rewardsShowCurrencyList: function() {
        return this.$store.state.user.rewards_show_currency_list;
    },
    rewardsShowCurrencyName: function() {
        return this.$store.state.user.rewards_show_currency_name;
    },
    showActionButtonInRewards: function() {
        return this.$store.state.user.show_action_button_in_rewards;
    },
    showCurrencyName: function() {
        return this.$store.state.user.show_currency_name;
    },
    showCurrencyList: function() {
        return this.$store.state.user.show_currency_list;
    },
    showActionButton: function() {
        return this.$store.state.user.show_action_button;
    },
  },
  methods: {
    isMobile: function() {
          var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    back() {

      if (window.webkit) {
        var entryPath = this.getCookie("flyy-entry-path");
        if (this.$route.path == "/" || this.$route.path == entryPath) {
          window.webkit.messageHandlers.handleMessage.postMessage({ action: "go-back" });
        } else {
          this.$router.back();
        }
      } else {
        this.$router.back();
      }

    },
    quizList() {
      if (window.webkit) {
        window.webkit.messageHandlers.handleMessage.postMessage({ action: "quiz-list" });
      }
    },
    quizDetails() {
      if (window.webkit) {
        window.webkit.messageHandlers.handleMessage.postMessage({ action: "quiz-details" });
      }
    },
    redirectTo(path, params) {
      this.$router.push({path: '/'+path, query: params });
    },
    getTranslatedText(text){
      try{
        // console.log(texts[text.toLowerCase()][this.langCode]);
        var newText = texts[text.toLowerCase()][this.langCode]
        if (newText == null || newText.length == 0) {
          newText = text
        }
        return newText;
      } catch(e) {
        // console.log(e+"~~~~~~~"+text);
        return text;
      }
    },
    clearTimer() {
      clearInterval(this.$store.state.timer);
    },
    clearTimerArray() {
      var arr = this.$store.state.timersArray;
      for (var i = 0; i < arr.length; i++) {
        // console.log("~~~~~~~~~~~"+arr[i]);
        clearTimeout(arr[i]);
      }
    },
    closeAlert() {
      this.alertPopup(false, "");
    },
    getFormattedDateTime(start, end) {
      var start_date_time = new Date(start);
      var end_date_time = new Date(end);

      var start = {};
      var end = {};
      var date_time = {};
      var months = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

      var formatted_start_hours;
      var formatted_start_mins;
      var formatted_end_hours;
      var formatted_end_mins;

      if(start_date_time.getHours() <= 9) {
        formatted_start_hours = "0"+start_date_time.getHours()
      } else {
        formatted_start_hours = start_date_time.getHours()
      }

      if(start_date_time.getMinutes() <= 9) {
        formatted_start_mins = "0"+start_date_time.getMinutes()
      } else {
        formatted_start_mins = start_date_time.getMinutes()
      }

      if(end_date_time.getHours() <= 9) {
        formatted_end_hours = "0"+end_date_time.getHours()
      } else {
        formatted_end_hours = end_date_time.getHours()
      }

      if(end_date_time.getMinutes() <= 9) {
        formatted_end_mins = "0"+end_date_time.getMinutes()
      } else {
        formatted_end_mins = end_date_time.getMinutes()
      }

      start.time = formatted_start_hours + ":" + formatted_start_mins;
      var start_date = start_date_time.getDate() <= 9 ? "0"+start_date_time.getDate() : start_date_time.getDate();
      start.date = start_date + " " +  months[start_date_time.getMonth()];
      date_time.start = start;

      end.time = formatted_end_hours + ":" + formatted_end_mins;
      var end_date = end_date_time.getDate() <= 9 ? "0"+end_date_time.getDate() : end_date_time.getDate();
      end.date = end_date + " " + months[end_date_time.getMonth()];
      date_time.end = end;
      return date_time;
    },
    getTimer(is_live, timing) {
      var dateEntered = new Date(timing);
      var now = new Date();
      var difference = dateEntered.getTime() - now.getTime();

      if (difference <= 0) {
        if(!this.$store.state.refreshTournament) {
          this.$store.state.refreshTournament = true;
          this.clearTimer();
        }
        if(is_live && this.$route.path != "/main_page") {
          this.alertPopup(true, "Tournament ended!");
          this.tournamentEnded();
        }
      } else {
        var seconds = Math.floor(difference / 1000);
        var minutes = Math.floor(seconds / 60);
        var hours = Math.floor(minutes / 60);
        var days = Math.floor(hours / 24);

        hours = hours %= 24;
        minutes = minutes %= 60;
        seconds = seconds %= 60;

        var formatted_days;
        if(days > 0) {
          formatted_days = ((days <= 9)  ? ("0" + days + "d:") : (days + "d:"));
        } else {
          formatted_days = "";
        }

        var formatted_hours = ((days > 0 || days == 0) && hours > 0) ? (hours <= 9 ? ("0" + hours + "h:") : hours + "h:") : "";
        var formatted_mins = (minutes <= 9 ? ("0" + minutes + "m:") : minutes + "m:");
        var formatted_secs = (seconds <= 9 ? ("0" + seconds + "s") : seconds + "s");
        var count_down = formatted_days + formatted_hours + formatted_mins + formatted_secs;
        this.$store.state.countDownTimer = count_down;
        this.$store.state.refreshTournament = false;
      }
    },
    getTimerForTimerArray() {
      var self = this;
      if (self.$route.path == "/main_page" || self.$route.path == "/game-zone") {
        setTimeout(function () {
          var all_tournaments = self.allTournamentsList;
          for (var i = 0; i < all_tournaments.length; i++) {
            var tr = all_tournaments[i]
            var is_live = tr.is_live;
            var timing = '';
            if (is_live) {
              timing = tr.ends_at;
            } else {
              timing = tr.starts_at;
            }
            var dateEntered = new Date(timing);
            var now = new Date();
            var difference = dateEntered.getTime() - now.getTime();

            if (difference <= 0) {
              if(is_live && (self.$route.path == "/main_page" || self.$route.path == "/game-zone")) {
                self.alertPopup(true, "Tournament ended!");
              }
            } else {
              var seconds = Math.floor(difference / 1000);
              var minutes = Math.floor(seconds / 60);
              var hours = Math.floor(minutes / 60);
              var days = Math.floor(hours / 24);

              hours = hours %= 24;
              minutes = minutes %= 60;
              seconds = seconds %= 60;

              var formatted_days;
              if(days > 0) {
                formatted_days = ((days <= 9)  ? ("0" + days + "d:") : (days + "d:"));
              } else {
                formatted_days = "";
              }

              var formatted_hours = ((days > 0 || days == 0) && hours > 0) ? (hours <= 9 ? ("0" + hours + "h:") : hours + "h:") : "";
              var formatted_mins = (minutes <= 9 ? ("0" + minutes + "m:") : minutes + "m:");
              var formatted_secs = (seconds <= 9 ? ("0" + seconds + "s") : seconds + "s");
              var count_down = formatted_days + formatted_hours + formatted_mins + formatted_secs;

              var tr_id = tr.id;
              var tr_data = {}
              tr_data[tr_id] = {tag: (is_live ? "Live" : "Starts"), time: count_down}
              // console.log(tr_data)
              var timerSpan = document.getElementById("tr_timer_"+tr.id);
              if (timerSpan) {
                timerSpan.innerHTML = count_down;
              }
              self.$store.state.tournamentStatus = self.jsonConcat(self.$store.state.tournamentStatus, tr_data)
            }
          }
          if((self.$route.path == "/main_page" || self.$route.path == "/game-zone")) {
            self.getTimerForTimerArray();
          }
        }, 1000);
      }
    },
    jsonConcat(o1, o2) {
     for (var key in o2) {
      o1[key] = o2[key];
     }
     return o1;
    },
    alertPopup(status, message) {
      this.$store.state.alert = status;
      this.$store.state.alertText = message;
    },
    tournamentEnded() {
      if(this.$ls.get("userData") != null) {
        var user_data = JSON.parse(this.$ls.get("userData"));
        user_data.tournamentID = "";
        this.$ls.set('userData', JSON.stringify(user_data));
      }
    },
    messageToShare(prize, type, name) {
      if(prize > 0) {
        prize = prize + " "
      } else {
        prize = ""
      }
      this.$store.state.shareText = "I'm winning" + " " + prize + type + " " +"on DealShare App by playing " + name;
    },
    timeAgo(date) {
      var seconds = Math.floor((new Date() - new Date(date)) / 1000);
      if(Math.round(seconds/(60*60*24*365.25)) >= 2) return Math.round(seconds/(60*60*24*365.25)) + " years ago";
      else if(Math.round(seconds/(60*60*24*365.25)) >= 1) return "1 year ago";
      else if(Math.round(seconds/(60*60*24*30.4)) >= 2) return Math.round(seconds/(60*60*24*30.4)) + " months ago";
      else if(Math.round(seconds/(60*60*24*30.4)) >= 1) return "1 month ago";
      else if(Math.round(seconds/(60*60*24*7)) >= 2) return Math.round(seconds/(60*60*24*7)) + " weeks ago";
      else if(Math.round(seconds/(60*60*24*7)) >= 1) return "1 week ago";
      else if(Math.round(seconds/(60*60*24)) >= 2) return Math.round(seconds/(60*60*24)) + " days ago";
      else if(Math.round(seconds/(60*60*24)) >= 1) return "1 day ago";
      else if(Math.round(seconds/(60*60)) >= 2) return Math.round(seconds/(60*60)) + " hours ago";
      else if(Math.round(seconds/(60*60)) >= 1) return "1 hour ago";
      else if(Math.round(seconds/60) >= 2) return Math.round(seconds/60) + " minutes ago";
      else if(Math.round(seconds/60) >= 1) return "1 minute ago";
      else if(seconds >= 2) return seconds + " seconds ago";
      else if(seconds == 1) return "1 second ago";
      else return seconds + "just now";
    },
    validateInput(type, value, msg) {
      var reg;
      if(type == 'phone') {
        reg = /^\d{10}$/
      } else if(type == 'otp') {
        reg = /^\d{4}$/
      } else if(type == 'account') {
        reg = /^\d{9,}/
      }

      msg = "Please enter a valid " + msg;
      var is_valid = reg.test(value);
      if(!is_valid) {
        var self = this;
        self.alertPopup(true, msg);
        setTimeout(function() {
          self.closeAlert();
        }, 2000);
        return false;
      } else {
        return true;
      }
    },
    isEmpty(obj) {
      for(var key in obj) {
        if(obj.hasOwnProperty(key))
          return false;
      }
      return true;
    },
    toggleGiftModal(state, content) {
      var curr_bal = parseInt(this.userHeaderBalance.balance.split(" ")[0]);
      if(curr_bal < content.currency_req) {
        this.toastPopup(true, 'Not enough balance!');
        return false;
      }

      this.$store.state.show_gift_modal = state;
      if(state == true) {
        this.$store.state.gift_content = content;
      } else {
        this.$store.state.gift_content = {};
        this.$store.state.giftCardBuy = true;
      }
      content.show_popup = state;
    },
    toggleMileStoneModal(state,content){
      content.show_popup = state;
      this.$store.state.show_mile_stone_modal = state;
    },
    redirectToTransactions() {
      var curr_type = this.userHeaderBalance.balance.split(" ")[1];
      this.$router.push({path: '/transactions', query: {type: curr_type}});
    },
    stripHTML(text) {
      if(!text) return '';
      var regexTD = /(<([^>]+)>)/ig;
      return text.replace(regexTD, '').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&nbsp;/g, ' ');
    },
    replaceNewLine(text) {
      if(!text) return '';
      let regexT = /\n/g;
      return text.replace(regexT,'<br>');
    },
    formatReward(type, reward, with_type) {
      var r = "";
      if(type) {
        if(type === "Cash") {
          if(with_type) {
            r = "₹"+reward.toString();
          } else {
            r = reward;
          }
        } else {
          if(with_type) {
            r = reward.toString() + ' ' + type;
          } else {
            r = reward.toString();
          }
        }
      }
      return r;
    },
    formatUserCheckins(offer) {
      if(offer && !this.isEmpty(offer)) {
        var milestone_points = this.userCheckins;
        var milestone_streak = offer.streak;
        var milestone_icon = offer.currency_icon_url;
        var currency_label = offer.currency_label;
        var tempArr = milestone_points.map((v) => {return parseInt(v.value)});
        var maxCount =  tempArr[tempArr.length - 1];
        var all_milestones = [];
        for(let i = 1; i <= maxCount; i++) {
          if(milestone_streak >= i) {
            if(tempArr.includes(i)) {
              all_milestones.push({
                is_checked: true,
                won: true,
                to_earn: true,
                show_popup: false,
                icon: milestone_icon,
                currency_label: currency_label,
                text: 'Won',
                min_price: milestone_points.filter((v)=> {return v.value == i})[0].min_price || 0,
                max_price: milestone_points.filter((v)=> {return v.value == i})[0].max_price || 0,
              });
            } else {
              all_milestones.push({
                is_checked: true,
                won: false,
                to_earn: false,
                show_popup: false,
                icon: milestone_icon,
                currency_label: currency_label,
                text: 'Day '+i,
                min_price: 0,
                max_price: 0,
              });
            }
          } else {
            if(tempArr.includes(i)) {
              all_milestones.push({
                is_checked: false,
                won: false,
                to_earn: true,
                show_popup: false,
                icon: milestone_icon,
                currency_label: currency_label,
                text: 'Earn',
                min_price: milestone_points.filter((v)=> {return v.value == i})[0].min_price || 0,
                max_price: milestone_points.filter((v)=> {return v.value == i})[0].max_price || 0,
              });
            } else {
              all_milestones.push({
                is_checked: false,
                won: false,
                to_earn: false,
                show_popup: false,
                icon: milestone_icon,
                currency_label: currency_label,
                text: 'Day '+i,
                min_price:  0,
                max_price:  0,
              });
            }
          }
        }
        this.$store.state.user.mile_stones = all_milestones;
        return all_milestones;
      } else {
        console.log("invalid offer!");
      }
    },
    formattedDate(date, with_space) {
      var d = new Date(date);
      var date = d.getDate();
      var month = (d.getMonth() + 1);
      var year = d.toLocaleDateString('en', {year: '2-digit'});
      var date = (date < 10) ? '0'+date : date;
      let time = d.toLocaleString('en-US', { hour: 'numeric', hour12: true, minute: 'numeric' });
      var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      if(with_space) {
        var i = month;
        month = months[i - 1];
        return date + ' ' + month + '\'' + year + ' '+ time;
      } else {
        month = (month < 10) ? '0'+month : month;
        return date + '-' + month + '-' + year+ ' '+ time;
      }
    },
    formatOfferTerms(terms) {
      return terms.replace(/<br>|&nbsp;/g, "").split(/<[^/].*?>(.*?)<\/.*?>|<.*?>/g).filter(x => (x != ""));
    },
    dailyCheckin(offer) {
      var self = this;
      if(offer && !self.isEmpty(offer)) {
        self.offer = offer
        var url = self.$store.getters.flyyDomain+"/checkin";
        var headers = self.$store.getters.headers;
        axios.get(url, {
          headers: headers
        }).then((resp) => {
          if(resp.status == 200) {
            self.offer.streak = resp.data.streak;
            self.offer.checked_in = resp.data.checked_in;
            self.formatUserCheckins(self.offer);
            self.$store.state.toastMsg = resp.data.message;
            self.$store.state.toast = true;
            self.$store.state
            setTimeout(() => {
              self.$store.state.toast = false;
            }, 2000);
          }
        }).catch((err) => {
          console.log("Something went wrong")
          console.log(err);
        })
      } else {
        console.log("Invalid offer");
      }
    },
    redirectToDeepLink(link) {
   /*   if (this.isMobile()) {
      }*/
      if (link.includes("spin-the-wheel")) {
        link += "&src=web"
      }
      window.location.href = link;
    },
    challengeRedirect(offer) {

      if((offer.click_action==='deeplink'||offer.click_action===null)&& offer.show_tnc === false && offer.tnc === null) {
          this.redirectToDeepLink(offer.deeplink);
          this.$store.state.headTitle = "Challenges";
        }
        else if(offer.click_action==='details' && offer.show_tnc === false && offer.tnc === null) {
        this.redirectTo('offers/'+offer.id,{showtnc:'false'});
        this.$store.state.headTitle = "Challenges";
      }
        else if(offer.click_action==='deeplink' && offer.tnc.length>0 && offer.tnc_accepted) {
        this.redirectToDeepLink(offer.deeplink);
        this.$store.state.headTitle = "Challenges";
        }
        else if(offer.click_action==='deeplink' && offer.tnc.length>0) {
        this.redirectTo('offers/'+offer.id,{showtnc:'true'});
        this.$store.state.headTitle = "Challenges";
       }
        else if(offer.click_action==='details' && offer.tnc.length>0) {
          this.redirectTo('offers/'+offer.id,{showtnc:'true'});
        this.$store.state.headTitle = "Challenges";
        }
        else if(offer.offer_sub_type==='spin_wheel' || offer.offer_sub_type==="bonanza") {
        this.redirectToDeepLink(offer.deeplink);
      }

    },
    redirectFromChallenge(deeplink) {
     history.pushState(null,'back',`${location.origin}`);//`${location.hostname}:${location.port?location.port:''}`);
      window.location.href = deeplink;

    },
    toastPopup(state, msg) {
      this.$store.state.toast = state;
      this.$store.state.toastMsg = msg;
      setTimeout(() => {
        this.$store.state.toastMsg = '';
        this.$store.state.toast = false;
      }, 2000);
    },
    getCurrencyLabels(currencies) {
      return currencies.map(curr => curr.label).join(', ');
    },
    formatOfferTitle(title) {
      if (!title) return ''
      title = title.split('_').join(" ");
      title = title.toString()
      return title.charAt(0).toUpperCase() + title.slice(1)
    },
    getAppInfo() {
      var url = this.$store.getters.flyyDomain + '/v7/flyy_app_info';
      var headers = this.$store.getters.headers;
      return axios.get(url, {
        headers: headers
      })
    },
    getWalletInfo() {
      var url = this.$store.getters.flyyDomain + '/web_wallet';
      var headers = this.$store.getters.headers;
      return axios.get(url, {
        headers: headers
      })
    },
    getBasicAppInfo() {
      var self = this;
      var headers = self.$store.getters.headers;
      axios.all([this.getAppInfo(), this.getWalletInfo()], {
        headers: headers
      }).then(axios.spread((info_resp, wallet_resp) => {
        if(info_resp.status == 200 && info_resp.data.success) {
          var data = info_resp.data;
          // console.log(data);
          self.$store.state.user.offers_show_currency_list = data.info.offers_show_currency_list;
          self.$store.state.user.offers_show_currency_name = data.info.offers_show_currency_name;
          self.$store.state.user.rewards_show_currency_list = data.info.rewards_show_currency_list;
          self.$store.state.user.rewards_show_currency_name = data.info.rewards_show_currency_name;
          self.$store.state.user.show_action_button_in_rewards = data.info.show_action_button_in_rewards;
          var bg_theme = data.info.bg_theme;

          if (window.webkit) {
            document.getElementById("status-bar").style.height = self.statusBarHeaderTop;
            document.getElementById("status-bar").style.backgroundColor = bg_theme;
          }

          var user_balances = data.info.balances;
          if (!self.$store.state.bg_theme || self.$store.state.bg_theme.length == 0) {
            self.$store.state.bg_theme = bg_theme;
          }
          self.$store.state.user.use_wallet = data.info.show_wallet;
        }

        if(wallet_resp.status == 200 && wallet_resp.data.success) {
          var data = wallet_resp.data.wallet_data;
          self.$store.state.user.balances = data;
          var wd = data.filter((wl) => {return wl.reward_type != 'Cash'});
          if(wd.length > 0) {
            wd = wd[0];
            var formatted_balance = self.formatReward(wd.reward_type, wd.balance, true);
            self.$store.state.user.headerBalance.icon = wd.reward_icon;
            self.$store.state.user.headerBalance.balance = formatted_balance;
            if(self.$route.path.includes('gift-card')) {
              self.$store.state.user.headerBalance.show = true;
            } else {
              self.$store.state.user.headerBalance.show = false;
            }
          }
        }
      })).catch((err) => {
        console.log("Something went wrong")
        console.log(err);
      })
    },
    extractURL(text) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      var link = "";
      text.replace(urlRegex, function(url) {
        link = url;
        return url;
      })
      return link;
    },
    getShareMsg(id, shareChannel) {
      var offer_id = (id ? id : -1);
      var url = this.$store.getters.flyyDomain + '/get_share_link/?offer_id='+offer_id;
      var headers = this.$store.getters.headers;
      var shareBaseURL = "";
      var self = this;
      axios.get(url, {
        mode: 'no-cors',
        headers: headers
      }).then((resp) => {
        if(resp.status == 200) {
          var data = resp.data;
          if(data.success) {
            var message = encodeURIComponent(data.message);
            var referralLink = encodeURIComponent(self.extractURL(data.message));
            switch(shareChannel) {
              case "wa":
                shareBaseURL = self.isOnMobile ? "whatsapp://send?text=" : "https://web.whatsapp.com/send?text=";
                break;
              case "tw":
                shareBaseURL = "https://twitter.com/intent/tweet?text=";
                break;
              case "gm":
                shareBaseURL = "mailto:?subject=Join%20Me&body=";
                break;
              case "sm":
                shareBaseURL = "sms:;?&body=";
                break;
              case "fb":
                shareBaseURL = "https://www.facebook.com/sharer/sharer.php?u=" + referralLink + "&quote=";
                break;
            }
            var shareURL = shareBaseURL+message;
            var msgData = {"action" : "openURL", url: shareURL };
            if (window.webkit) {
              window.webkit.messageHandlers.handleMessage.postMessage({ action: "share", share_url: shareBaseURL, share_from: shareChannel, message: data.message });
            } else {
              // if (shareChannel == null && navigator.share) {
              //   const shareData = {
              //     title: 'MDN',
              //     text: 'Learn web development on MDN!',
              //     url: 'https://developer.mozilla.org',
              //   }
              //   navigator.share(shareData);
              // }
              //self.copyToClipboard(data.message);
              if(shareChannel !== 'cp') {
                window.open(shareURL,"_blank");
              } else {
                self.copyToClipboard(data.message);
              }

              //below code causing old correct data to get overwritten with msgData
              // window.parent.postMessage(JSON.stringify(msgData), "*");
            }
          }
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    copyToClipboard(text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);

      document.getElementById("copied-toast").style.display = 'block';
      setTimeout(function() {
        document.getElementById("copied-toast").style.display = 'none';
      }, 2000)

    },
    loadDataFromCookie() {
      var headerData = this.getCookie("flyy-data")
      // console.log("header data - " + headerData)
      if (headerData) {
        console.log("inside header data");

        var data = null;
        try{
          data = JSON.parse(headerData);
        } catch (e){
          console.log("Json parse exception");
        }
        if (data != null) {
          var headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "X-Package-Name": data["package_name"],
            "X-SDK-Version-Code": data["sdk_version_code"],
            "X-SDK-Version-Name": data["sdk_version_name"],
            "X-App-Version-Code": data["app_version_code"],
            "X-App-Version-Name": data["app_version_name"],
            "X-Android-Id": data["android_id"],
            "X-GAID": data["gaid"],
            "X-App-Data": data["app_data"],
            "X-User-Token": data["user_token"],
            "X-Key": (data["api_key"] || data["partner_id"]),
            "X-Token": data["ext_user_token"]
          };
          if(data["Environment"]) {
            this.$store.state.environment = data["Environment"];
          } else {
            this.$store.state.environment = data["environment"];
          }
          if(data["theme_color_primary"]) {
            this.$store.state.bg_theme = data["theme_color_primary"];
          }
          if(data["ext_uid"]) {
            this.$store.state.user.ext_uid = data["ext_uid"];
          } else if(data["user_token"]){
            this.$store.state.user.ext_uid = data["user_token"];
          }
          this.$store.state.partner = (data["api_key"] || data["partner_id"]);
          // console.log("headers - " + headers);
          this.$store.dispatch('setHeaders', headers)
          this.getBasicAppInfo();
        }
      }
    },
    getFlyyAppinfov1() {
      var self  = this;
      if(self.hasPartnerToken){
        axios.all([this.getAppInfo()])
        .then(axios.spread((resp) => {
          if(resp.status == 200) {
            var data = resp.data;
            if(data.success) {
              self.getBasicAppInfo();
              self.all_offers = data.info.offers;
              self.$store.state.user.userName = data.info.user_name || "User";

              if(self.all_offers && self.all_offers.length > 0) {
                var tempOfferCheck = self.all_offers.filter((o) => {return o.offer_type_code.includes("checkin")})
                if(tempOfferCheck.length > 0) {
                  self.isCheckIn = true;
                  self.$store.state.user.milestones = tempOfferCheck[0].milestones;
                } else {
                  self.isCheckIn = true;
                }
                if(self.allOffers && self.allOffers.length > 0) {
                  var tempOfferCheck = self.allOffers.filter((o) => {return o.offer_type_code.includes("checkin")})
                  if(tempOfferCheck.length > 0) {
                    self.isCheckIn = true;
                    self.$store.state.user.milestones = tempOfferCheck[0].milestones;
                  } else {
                    self.isCheckIn = true;
                  }
                  var tempOfferGam = self.all_offers.filter((o) => {return o.offer_type_code.includes("gamification")})
                  self.$store.state.hasGamification = (tempOfferGam.length > 0) ? true : false;
                  self.$store.state.user.currLevel = (tempOfferGam.length > 0) ? tempOfferGam[0].current_level : "";
                  self.$store.state.user.currLevelIcon = (tempOfferGam.length > 0) ? tempOfferGam[0].current_level_icon_url : "";
                }
              }
              this.is_shimmer = false;
            } else {
              this.is_shimmer = false;
            }
          } else {
            this.is_shimmer = false;
          }
        })).catch((err) => {})
      } else {
        console.log("No partner token found!!!");
      }
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
    },
    updateStoreUserData() {
      var user = JSON.parse(this.$ls.get("userData"));
      this.$store.state.user.phone = user.phone;
      this.$store.state.user.userName = user.userName;
      this.$store.state.user.rank = user.rank;
      this.$store.state.user.joined = user.joined;
      this.$store.state.user.ext_uid = user.ext_uid;
      this.$store.state.partner = user.partner;
      this.$store.state.game = user.game;
      this.$store.state.bg_theme = user.bg_theme;
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    uppercase: function (value) {
      if (!value) return ''
      return value.toUpperCase()
    },
  },
  created() {
    this.getBasicAppInfo();
    // if(this.$ls.get("userData") == null) {
      var user = this.$store.state.user;
      user.partner = this.$store.state.partner;
      user.userName = this.$store.state.user.userName;
      user.ext_uid = this.$store.state.user.ext_uid;
      user.phone = this.$store.state.user.phone;
      user.joined = this.$store.state.user.joined;
      user.rank = this.$store.state.user.rank;
      user.game = this.$store.state.game;
      user.bg_theme = this.$store.state.bg_theme;
      this.$ls.set("userData", JSON.stringify(user));
    // } else {
    //   this.updateStoreUserData();
    // }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/globals.js